export default __webpack_public_path__ + "static/media/Disable.ec3b25e7.svg";